import React from "react";
import PropTypes from "prop-types";
import {ACol, AContainer, ARow} from "@cisco-sbg-ui/magna-react";
import classNames from "classnames";
import {Trans, useTranslation} from "react-i18next";
import Chip from "components/Chip";
import {getIncidentPriorityScoreColor} from "utils/priorityScore";
import css from "./PriorityScoreBreakdown.module.scss";

export default function PriorityScoreBreakdown({
  incident,
  showGlobalScore = false
}) {
  const {t} = useTranslation();
  const {scores} = incident;
  if (!scores) return null;

  const CalculationScore = ({score, i18nKey, ...rest}) => (
    <ACol
      cols="auto"
      className={classNames(css.scoreWrapper, {
        [css.withoutGlobalScore]: !showGlobalScore
      })}>
      <Chip small readOnly className={css.calculationScore} {...rest}>
        {score}
      </Chip>
      <div className={css.scoreLabel}>
        <Trans
          i18nKey={i18nKey}
          components={{
            div: <div />
          }}
        />
      </div>
    </ACol>
  );

  return (
    <AContainer fluid className="pa-0" data-testid="Score-Breakdown">
      <ARow noGutters>
        {showGlobalScore && (
          <ACol cols="auto">
            <span
              data-testid={`Global-Score-${scores?.global}`}
              className={css.priorityScore}
              style={{
                color: getIncidentPriorityScoreColor(scores?.global)?.background
              }}>
              {scores?.global}
            </span>
          </ACol>
        )}
        <CalculationScore
          score={scores?.ttp}
          i18nKey={t("incidents.priorityScore.ttpLabel")}
          data-testid={`TTP-Score-${scores?.ttp}`}
        />
        <CalculationScore
          score={scores?.asset}
          i18nKey={t("incidents.priorityScore.assetLabel")}
          data-testid={`Asset-Score-${scores?.asset}`}
        />
      </ARow>
    </AContainer>
  );
}

PriorityScoreBreakdown.propTypes = {
  /**
   * Incident object
   */
  incident: PropTypes.object.isRequired,
  /**
   * If true, the global incident score will show
   *
   * @defaultValue false
   */
  showGlobalScore: PropTypes.bool
};
